import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Card, InfoBar } from 'ui/components';
import { FormattedMessage } from 'ui/i18n';

import HandToolsImage from 'ui/assets/images/groups/HandWhite.jpg';
import PowerToolsImage from 'ui/assets/images/groups/PowerWhite.jpg';
import ToolStorageImage from 'ui/assets/images/groups/TStorageWhite.jpg';
import ShopTechImage from 'ui/assets/images/groups/ShopTechWhite.jpg';
import DiagnosticsImage from 'ui/assets/images/groups/DiagnosticsWhite.jpg';

import SOLOSplash from 'ui/assets/images/SOLO.jpg';
import './HomePage.scss';

const product_groups = [
	{
		name: 'Hand Tools',
		image: HandToolsImage,
		code: 'hand-tools',
	},
	{
		name: 'Power Tools',
		image: PowerToolsImage,
		code: 'power-tools',
	},
	{
		name: 'Tool Storage',
		image: ToolStorageImage,
		code: 'tool-storage',
	},
	{
		name: 'Shop and Tech',
		image: ShopTechImage,
		code: 'shop-and-tech',
	},
	{
		name: 'Diagnostics',
		image: DiagnosticsImage,
		code: 'diagnostics',
	},
];

export default class HomePage extends Component {
	static propTypes = {
		history: PropTypes.object.isRequired,
		location: PropTypes.object.isRequired,
	};

	constructor(props) {
		super(props);
		this.shouldClearCache();
	}

	shouldClearCache() {
		const shouldClearCache =
			this.props.location.state && this.props.location.state.fromSubmitOrder
				? this.props.location.state.fromSubmitOrder
				: false;

		if (shouldClearCache) {
			this.props.history.replace({
				pathname: this.props.location.pathname,
				state: {},
			});
			window.location.reload();
		}
	}

	render() {
		return (
			<div className="HomePage">
				<InfoBar>
					<p>
						<FormattedMessage id="home.pleaseNoteMessage" />
					</p>
				</InfoBar>
				<div className="ProductGroups">
					{product_groups.map(g =>
						<Card className="ProductGroups-item" key={g.code}>
							<Link to={`/product-group/${g.code}`} key={g.code}>
								<img src={g.image} alt={g.name} />
								<h3>
									<FormattedMessage id={g.code} />
								</h3>
							</Link>
						</Card>
					)}
				</div>
				<Card className="SoloSplash">
					<img src={SOLOSplash} alt="SOLO" />
				</Card>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/pages/Home/index.js